import { Component, OnInit } from '@angular/core';
import VersionInfo from '../../../../package.json';

@Component({
    standalone: false,
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  public version: string = VersionInfo.version;
  constructor() { }

  ngOnInit(): void {
  }

}
